import { HistSeller } from './hist-seller';
import { HistSellerCreationInfo } from './hist-seller-creation-info';

export class HistSellerBatchChanges {
    inserts: HistSeller[];
    updates: HistSeller[];
    deletes: number[];
}
